import FlexBox from '@/atomic-components/FlexBox';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Typography } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { useState } from 'react';
import TickIcon from '../../../../../assets/pdp/tick.svg';
import ConfigModal from './configModal';
import { ListingService as ProductService } from '../../../../../services/catalogue/index';
import { useLocation } from '@/hooks/useLocation';
import { emitMoeEvent } from '@/utils/dataLayer';
import { useRouter } from 'next/router';

export interface VariantConfiguration {
	configurations: Configuration[];
	product: any;
}

export interface Configuration {
	label: string;
	options: Option[];
	name: string;
}
export interface Option {
	value: string;
	selected?: boolean;
}
export interface IVariantConfiguration {
	variantConfiguration: VariantConfiguration;
	variantGroupId: number;
	label?: string;
	condition?: string;
	priceData: any;
	promiseDate: any;
	setConfiguration: Function;
	selectedTenure: number;
	isAvailable: boolean;
}

const VariantConfiguration = (props: IVariantConfiguration) => {
	const [openConfigModel, setOpenConfigModel] = useState(false);

	const router = useRouter();
	const searchParams = new URLSearchParams();
	const { selectedLocation, locationActions } = useLocation();
	const hasHiddenVariants = props?.variantConfiguration?.configurations?.find(
		(config: any) => config.visibleOnDetails === false
	);

	const handleChange = (
		e: any,
		d: string,
		screen_name: string,
		isPdpConfigs?: boolean
	) => {
		searchParams.append(`intent[${d}]`, e);
		const configData = props.variantConfiguration.configurations.filter(
			(config: any) => {
				return config.name !== d;
			}
		);

		const preselectedConfigs = configData?.map((data: any) => {
			return {
				name: data.name,
				filter: data?.options?.filter((d: any) => {
					return d.selected == true;
				})[0],
			};
		});

		preselectedConfigs.forEach((element: any) => {
			searchParams.append(`config[${element.name}]`, element.filter.value);
		});
		searchParams.append(
			'cityId',
			(selectedLocation.cityId?.toString() as string) ?? '1'
		);
		ProductService.getProductConfig(
			props.variantGroupId,
			searchParams.toString()
		)

			.then((res) => {
				props.setConfiguration(res.data.data);
				if (isPdpConfigs) {
					router.push(res?.data?.data?.product?.permalink);
				}
			})
			.catch((err) => {
				console.log(err);
			});
		emitMoeEvent('Variant tapped', {
			variant_name: e,
			variant_category: d,
			screen_name: screen_name,
			Product_id: props?.variantConfiguration?.product?.id,
		});
	};

	return (
		<FlexBox direction='column' gap='4px'>
			{props?.variantConfiguration &&
				props?.variantConfiguration?.configurations?.map((configs: any) => {
					if (!configs.visibleOnDetails) {
						return;
					}

					const labelName = configs.label;

					return (
						<>
							<LencoTypography
								sx={{
									...getStyle('H14_Medium'),
									color: getColor('Gray -1'),
									paddingBottom: '4px',
								}}
							>
								{labelName} :
							</LencoTypography>
							<LencoTypography sx={{ ...getStyle('Small_Regular') }}>
								{configs.options?.length} options available
							</LencoTypography>
							<FlexBox
								direction='column'
								sx={{
									flexWrap: 'wrap',
									paddingBottom: '8px',
									overflow: 'hidden',
								}}
							>
								<FlexBox
									gap='10px'
									sx={{
										overflow: 'scroll',
										maxWidth: '400px',
										whiteSpace: 'nowrap',
										'::-webkit-scrollbar': {
											display: 'none',
										},
									}}
								>
									{[
										...configs.options.filter((i: any) => i.selected),
										...configs.options.filter((i: any) => !i.selected),
									].map((d: any, optionIndex: any) => {
										const borderColor = d.selected ? 'Minty 0' : 'Gray -4';
										const bgColor = d.selected ? 'Navy -6' : '#FFFFFF';
										return (
											<FlexBox
												key={optionIndex}
												onClick={() => {
													if (d?.selected) return;
													handleChange(d.value, configs.name, 'PDP', true);
												}}
												sx={{
													backgroundColor: getColor(`${bgColor}`),
													border: `1px solid ${getColor(`${borderColor}`)}`,
													padding: '8px 18px 8px 18px',
													borderRadius: '8px',

													color: getColor(d.selected ? 'Minty 0' : 'Gray -1'),

													cursor: 'pointer',
												}}
											>
												<LencoTypography
													id='typo'
													sx={{
														...getStyle('Small-Regular'),
														whiteSpace: 'nowrap',
														paddingTop: '2px',
													}}
												>
													{d.value}
												</LencoTypography>
											</FlexBox>
										);
									})}
								</FlexBox>
							</FlexBox>
						</>
					);
				})}

			{hasHiddenVariants && (
				<Typography
					sx={{
						...getStyle('P_Medium'),
						color: getColor('Gray -1'),
						textDecoration: 'underLine',
						textAlign: 'end',
						cursor: 'pointer',
					}}
					onClick={() => setOpenConfigModel(true)}
				>
					{'Other Variants >'}
				</Typography>
			)}
			{props?.variantConfiguration && (
				<ConfigModal
					variantConfiguration={props.variantConfiguration}
					label={props.label}
					condition={props.condition}
					variantGroupId={props.variantGroupId}
					priceData={props.priceData}
					promiseDate={props.promiseDate}
					setConfiguration={props.setConfiguration}
					selectedTenure={props.selectedTenure}
					setOpenConfigModel={setOpenConfigModel}
					openConfigModel={openConfigModel}
					isAvailable={props?.isAvailable}
					handleChange={handleChange}
				/>
			)}
		</FlexBox>
	);
};

export default VariantConfiguration;
